import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import { HorizontalScroll } from "../horizontal-scroll";
import { Icon } from "../Icon";
import { useAsync } from "../../utils/hooks/useAsync";
import { heroServices } from "../../services/hero";
import useDevice from "../../utils/hooks/useDevice";

const HomeImagesScroll: FunctionComponent = ({}) => {
  const { data: heroImages, isSuccess, run } = useAsync<Hero[], string>();
  const [widthState, setWidthState] = useState<number>(1920);
  const location = useLocation();
  const ref = useRef<HTMLDivElement>(null);

  const { isMobile } = useDevice();

  useEffect(() => {
    run(heroServices.getHero({ mobileHero: isMobile }));
  }, [isMobile]);

  useEffect(() => {
    try {
      ref.current && setWidthState(ref.current?.offsetWidth);
    } catch (e) {
      console.log(
        "[DEBUG/HeroImagesScroll] - error building hero images - ",
        e
      );
    }
  }, [heroImages]);

  if (location.pathname === "/" && isSuccess)
    return (
      <section className="home_images_container" draggable="true" ref={ref}>
        <HorizontalScroll
          scrollBy={widthState}
          items={heroImages?.length}
          paddingInBtns={true}
          isHero={true}
        >
          {heroImages && heroImages.length > 0
            ? heroImages?.map((img) => {
                return (
                  <div key={img.urlImage} className="home_images">
                    <img
                      draggable="true"
                      src={img.urlImage}
                      alt="scroll image"
                      className="home_img"
                    />
                    <a href="#navBar" className="img_icon3">
                      <Icon iconName="mousse_icon" />
                    </a>
                  </div>
                );
              })
            : null}
        </HorizontalScroll>
      </section>
    );
  else {
    return null;
  }
};

export default HomeImagesScroll;
